// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"9ff9780f","453":"0c8ff8c9","576":"b910ff26","577":"b55c73dc","585":"3b7e8e40","716":"0616c88e","847":"276a3148"}[chunkId] + ".chunk.js";
};